import ArtDecoContainer from "@components/ArtDecoContainer"
import Box from "@components/Box"
import { Form, H2, Paragraph } from "@components/RichTextAndTypography"
import axios from "axios"
import { AnimatePresence } from "framer-motion"
import React, { useState } from 'react'
import { StyledButton, StyledInput } from "./styles"

const FormEmailCapture = () => {
  const statuses = {
    TYPING: 'typing',
    SUBMITTING: 'submitting',
    SUCCESS: 'success'
  }

  const [email, setEmail] = useState('')
  const [error, setError] = useState(null)
  const [status, setStatus] = useState(statuses.TYPING)

  const validateEmail = email => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)

  const handleInputChange = e => {
    setEmail(e.target.value)
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (!email || !validateEmail(email)) {
      setError({ message: 'Please enter a valid email' })
      return
    }

    setStatus(statuses.SUBMITTING)

    axios.post(process.env.GATSBY_EMAIL_CAPTURE_URL, { email })
      .then(response => {
        setStatus(statuses.SUCCESS)
      })
      .catch(error => {
        setStatus(statuses.TYPING)
        setError({
          message: (error?.response?.data && JSON.parse(error?.response?.data)?.message) || error?.message || 'Sorry. Something went wrong.'
        })
      })
  }

  return (
    <ArtDecoContainer textAlign="center" px={["16px", "32px", "64px"]}>
      <H2
        mb="48px"
        fontSize="40px"
        lineHeight="40px"
        letterSpacing="0.02em"
        color="white"
      >
        JOIN HELL IS OTHERS
      </H2>
      <Box
        minHeight="150px"
        display="flex"
        justifyContent="center"
      >
        <AnimatePresence initial={false} mode="wait">
          {status === statuses.SUCCESS ? (
            <Paragraph
              fontSize={['20px', null, '26px']}
              fontWeight={400}
              lineHeight={['32px', null, '36px']}
              key="success-message"
              animated
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
            >
              Welcome to the neighborhood!
            </Paragraph>
          ) : (
            <Form
              onSubmit={handleSubmit}
              display="flex"
              flexDirection="column"
              alignItems="stretch"
              justifyContent="space-between"
              width="100%"
              key="form-capture-email"
              animated
              animate={{ opacity: status === statuses.SUBMITTING ? .5 : 1 }}
              exit={{ opacity: 0 }}
            >
              <Box textAlign="left">
                <label htmlFor="emailInput">
                  <StyledInput
                    placeholder="ENTER YOUR EMAIL"
                    type="text"
                    inputMode="email"
                    aria-required="true"
                    id="emailInput"
                    name="email"
                    value={email}
                    onChange={handleInputChange}
                    disabled={status === statuses.SUBMITTING}
                    display="block"
                    width="100%"
                    p="8px"
                    fontFamily="body"
                    fontWeight={300}
                    fontSize="16px"
                    lineHeight="28px"
                    color="black"
                    background="rgba(217, 217, 217, 0.8)"
                    border="2px solid"
                    borderColor="rgba(0, 0, 0, 0)"
                  />
                  {error && (
                    <Paragraph px="8px">
                      {error?.message}
                    </Paragraph>
                  )}
                </label>
              </Box>
              <StyledButton
                disabled={status === statuses.SUBMITTING}
                display="block"
                alignSelf="center"
                border="none"
                width="fit-content"
                color="tanMedium"
                bg="red"
                p="12px 40px"
                borderRadius="30px"
                fontFamily="headings"
                fontWeight="700"
                fontSize="24px"
                lineHeight="28px"
              >
                SIGN UP
              </StyledButton>
            </Form>
          )}
        </AnimatePresence>
      </Box>
    </ArtDecoContainer>
  )
}

export default FormEmailCapture
